<template>
  <div class="aira-dev">
    <p class="aira-dev__title">Aira dev</p>

    <p v-if="!isReady" class="aira-dev__note">rive не загружен</p>
    <p v-else-if="!propertyNames.length" class="aira-dev__note">
      view model без свойств
    </p>

    <label v-for="name in propertyNames" :key="name" class="aira-dev__row">
      <input type="checkbox" :checked="flags[name] ?? false" @change="toggle(name, $event)" />
      {{ name }}
    </label>

    <div class="aira-dev__row">
      <input v-model="text" class="aira-dev__input" placeholder="текст бабла" />
      <button type="button" @click="say">say</button>
      <button type="button" @click="clear">clear</button>
    </div>

    <div class="aira-dev__row">
      <button type="button" @click="aira.hide()">hide</button>
      <button type="button" @click="aira.show()">show</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import { useAira } from "../composables/useAira";

// Keeping the panel mounted across route changes would fight the page that owns
// the hint, so it opts out of the automatic reset.
const aira = useAira({ resetOnDispose: false });
const { isReady, propertyNames } = aira;

const flags = reactive<Record<string, boolean>>({});
const text = ref("Эти джинсы садятся маломерно");

function toggle(name: string, event: Event) {
  const value = (event.target as HTMLInputElement).checked;
  flags[name] = value;
  aira.write(name, value);
}

function say() {
  aira.say(text.value);
  flags.wantsToSay = true;
}

function clear() {
  aira.clearHint();
  flags.wantsToSay = false;
}
</script>

<style scoped>
.aira-dev {
  position: fixed;
  right: 16px;
  bottom: 140px;
  z-index: 1200;
  width: 230px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgb(20 18 28 / 92%);
  color: #fff;
  font: 12px/1.4 ui-monospace, SFMono-Regular, Menlo, monospace;
}

.aira-dev__title {
  margin: 0 0 6px;
  opacity: 0.6;
}

.aira-dev__note {
  margin: 0 0 6px;
  color: #ffb4a2;
}

.aira-dev__row {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-bottom: 4px;
}

.aira-dev__input {
  flex: 1;
  min-width: 0;
  padding: 3px 5px;
  border: none;
  border-radius: 4px;
  font: inherit;
}

button {
  padding: 3px 7px;
  border: none;
  border-radius: 4px;
  background: #4b4363;
  color: #fff;
  font: inherit;
  cursor: pointer;
}
</style>
